<template>
    <div>
        <b-modal 
            :model-value="modalAdCentroCostos" 
            @update:model-value="updateModalValue"
            :no-close-on-backdrop="true" 
            hide-header 
            hide-footer 
            centered
        >
            <div class="text-center mb-3">
		<h5>{{ labels.title }} Contrato {{ numContrato}}</h5>
            </div>
            
            <div class="container-fluid">
                <div v-if="listCentroCostos && listCentroCostos.length > 0">
                    
                    <b-row class="mb-3 align-items-center">
                        <b-col cols="4">
                            <h5>{{ labels.centroCosto }}</h5>
                        </b-col>
                        <b-col cols="8">
                            <select 
                                class="form-control"
                                @change="handleSelectChange"
                                ref="selectCentroCosto"
                                v-bind="selectAttributes"
                            >
                                <option value="">Seleccione...</option>
                                <option 
                                    v-for="(centroCostosSel, index) in listCentroCostos" 
                                    :key="centroCostosSel?.id || index" 
                                    :value="centroCostosSel?.centro_costo"
                                >
                                    {{ centroCostosSel?.descripcion }} ({{ centroCostosSel?.centro_costo }})
                                </option>
                            </select>
                        </b-col>
                    </b-row>
                    
                    <b-row class="mb-3 align-items-center">
                        <b-col cols="4">
                            <h5>{{ labels.porcentaje }}</h5>
                        </b-col>
                        <b-col cols="8">
                            <input 
                                type="number" 
                                v-model="porcentaje" 
                                class="form-control" 
                                min="0" 
                                max="100"
                                step="0.01"
                                @input="onPorcentajeChange"
                            >
                        </b-col>
                    </b-row>
                </div>
                
                <div v-else>
                    <b-row class="justify-content-center">
                        <h6>{{ labels.noData }}</h6>
                    </b-row>
                    <!-- Debug: mostrar datos recibidos -->
                    <div class="alert alert-warning">
                        Datos recibidos: {{ listCentroCostos }}
                    </div>
                </div>
                
                <!-- Botones de acción -->
                <b-row class="mt-3">
                    <b-col cols="6" class="text-center">
                        <b-button 
                            variant="primary" 
                            @click="aceptaCentroCostos" 
                            :disabled="!centroCosto || !porcentaje"
                        >
                            {{ labels.save }}
                        </b-button>
                    </b-col>
                    <b-col cols="6" class="text-center">
                        <b-button variant="secondary" @click="cierraModal">
                            {{ labels.close }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ContratoCentroCostos from '../../services/ContratoCentroCostos'
import CentroCostos from '../../services/CentroCostos'

export default {
    name: 'AdicionarCentroCostos',
    props: {
        modalAdCentroCostos: {
            type: Boolean,
            default: false
        },
        numContrato: {
            type: [String, Number],
            required: true
        },
        vigencia: {
            type: [String, Number],
            required: true
        },
        newVigencia: {
            type: [String, Number],
            default: ''
        }
    },
    emits: ['update:modalAdCentroCostos', 'cierraModal', 'reloadTblCntCst'],
    data: () => ({
        centroCosto: '',
        porcentaje: '',
        listCentroCostos: [],
        listContrato: [],
        selectAttributes: {
            // Atributos adicionales para el select si son necesarios
        }
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: 'Adicionar centro de costo',
                    save: 'Guardar',
                    close: 'Cerrar',
                    detalle: 'Modificación Detalle',
                    activos: 'Modificación CentroCostos',
                    cuotas: 'Cuotas',
                    noData: 'No hay Centros de Costos disponibles.',
                    centroCosto: "Centro Costo",
                    porcentaje: "Porcentaje",
                }
            } else {
                return {
                    title: 'Add cost center',
                    save: 'Save',
                    close: 'Close',
                    detalle: 'Detail',
                    activos: 'Assets',
                    cuotas: 'Cuotas',
                    noData: 'No assets available.',
                    centroCosto: "Cost Center",
                    porcentaje: "Percentage",
                }
            }
        }
    },
    methods: {
        
        // Método para manejar el cambio del select manualmente
        handleSelectChange(event) {
            const selectedValue = event.target.value
            this.centroCosto = selectedValue
        },
        
        // Método para actualizar el valor del modal desde el padre
        updateModalValue(value) {
            this.$emit('update:modalAdCentroCostos', value)
            if (!value) {
                this.resetForm()
            }
        },
        
        // Método para resetear el formulario
        resetForm() {
            this.centroCosto = ''
            this.porcentaje = ''
            if (this.$refs.selectCentroCosto) {
                this.$refs.selectCentroCosto.value = ''
            }
        },
        
        cierraModal() {
            this.$emit('cierraModal', false)
            this.$emit('update:modalAdCentroCostos', false)
            this.resetForm()
        },
        
        aceptaCentroCostos() {
            console.log('Datos a enviar:', {
                numContrato: this.numContrato,
                vigencia: this.vigencia,
                newVigencia: this.newVigencia,
                centroCosto: this.centroCosto,
                porcentaje: this.porcentaje
            })

            if (!this.centroCosto || !this.porcentaje) {
                this.$toast?.error('Por favor seleccione un centro de costo y asigne un porcentaje.')
                return
            }

            const info = {
                'numContrato': this.numContrato,
                'vigencia': this.vigencia,
                'newVigencia': this.newVigencia == '' ? this.vigencia : this.newVigencia,
                'centroCosto': this.centroCosto,
                'porcentaje': this.porcentaje,
                'idUser': this.$store.state.userId
            }

            const porcentajeNum = parseFloat(info.porcentaje)
            if (isNaN(porcentajeNum) || porcentajeNum <= 0 || porcentajeNum > 100) {
                this.$toast?.error('El porcentaje debe ser un número entre 1 y 100.')
                return
            }

            ContratoCentroCostos.adicionaCentroCosto(info)
                .then((response) => {
                    this.$toast.success(response.data.message || 'Centro de costo adicionado correctamente')
                    this.$emit('reloadTblCntCst', this.vigencia)
                    this.resetForm()
                    this.cierraModal()
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        this.$toast.error(error.response.data.message)
                    } else {
                        this.$toast.error('Error al adicionar el centro de costo')
                    }
                })
        },
        
        // Método para cargar centros de costo
        cargarCentrosCostos() {
            CentroCostos.getAllCentroCostos()
                .then((res) => {
                    this.listCentroCostos = res.data?.listCentroCostos || []
                })
                .catch((err) => {
                    console.error('Error al cargar centros de costo:', err)
                    this.$toast?.error('Error al cargar los centros de costo disponibles')
                })
        }
    },
    mounted() {
        this.cargarCentrosCostos()
    },
    watch: {
        modalAdCentroCostos(newVal) {
            if (newVal) {
                this.resetForm()
                // Recargar datos cuando se abre el modal
                this.cargarCentrosCostos()
            }
        },
        // Watch para debuggear cambios en listCentroCostos
        listCentroCostos: {
            handler(newVal) {
                console.log('listCentroCostos actualizado:', newVal)
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.container-fluid {
    padding: 0;
}

.b-table-cell-container {
    padding: 15px !important;
}

.b-table-head-label {
    padding-left: 30px !important;
}

.text-muted {
    display: block;
    margin-top: 5px;
    font-size: 12px;
}

.alert {
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 4px;
}

.alert-info {
    background-color: #d1ecf1;
    border-color: #bee5eb;
    color: #0c5460;
}

.alert-warning {
    background-color: #fff3cd;
    border-color: #ffeeba;
    color: #856404;
}
</style>
